module.exports = __webpack_public_path__ + "img/products_big_can_bubblegum.c24e2afa.png";